import React from 'react';
import PageForm from '../components/PageForm';

function Home() {
  return <PageForm />;
}

export default Home;
